import React, { useEffect, useRef, useState } from 'react';

export function useElapsedSeconds(active = true) {
    const [elapsedSeconds, setElapsedSeconds] = useState(0);

    useEffect(() => {
        if (!active) {
            setElapsedSeconds(0);
            return undefined;
        }
        const startedAt = Date.now();
        setElapsedSeconds(0);
        const timer = window.setInterval(() => {
            setElapsedSeconds(Math.floor((Date.now() - startedAt) / 100) / 10);
        }, 100);
        return () => window.clearInterval(timer);
    }, [active]);

    return elapsedSeconds;
}

export default function LoadingElapsed({ active = true, text = 'Yükleniyor', className = '', logOnComplete = true }) {
    const elapsedSeconds = useElapsedSeconds(active);
    const startedAtRef = useRef(null);
    useEffect(() => {
        if (!active) return undefined;
        startedAtRef.current = performance.now();
        return () => {
            if (!logOnComplete || startedAtRef.current == null) return;
            const duration = (performance.now() - startedAtRef.current) / 1000;
            console.info(`[loading-sure] ${text}: ${duration.toFixed(3)} sn`);
        };
    }, [active, logOnComplete, text]);
    if (!active) return null;
    return <span className={className}>{text} ({elapsedSeconds.toFixed(1)} sn)</span>;
}
